<div class="stock-lot-modal">
  <div class="modal-header">
    <div>
      <h2>{{ 'pages.stock.lots.edit_lot' | translate }}</h2>
      <!-- <span class="product-info">{{ data.productName }}</span> -->
    </div>
  </div>

  <form *ngIf="stockLotForm" id="stock-lot-form" [formGroup]="stockLotForm" class="modal-content">
    <div class="form-row">

      <div class="form-group">
        <label for="quantity">{{ 'pages.stock.lots.quantity' | translate }}*</label>
        <input type="number" id="stockQuantity" [formControl]="stockLotForm.controls.stockQuantity" class="form-input"
          [class.error]="stockLotForm.controls.stockQuantity.invalid && stockLotForm.controls.stockQuantity.touched">
        <ng-container *ngIf="stockLotForm.controls.stockQuantity.errors">
          <div class="error-message"
            *ngIf="stockLotForm.controls.stockQuantity.errors['required'] && stockLotForm.controls.stockQuantity.touched">
            {{ 'pages.stock.lots.validation.quantity' | translate }}
          </div>

          <div class="error-message"
            *ngIf="stockLotForm.controls.stockQuantity.errors['min'] && stockLotForm.controls.stockQuantity.touched">
            {{ 'pages.stock.lots.validation.min_quantity' | translate }}
          </div>
        </ng-container>

      </div>

      <div class="form-group">
        <label for="price">{{ 'pages.stock.lots.price' | translate }}*</label>
        <input type="number" id="price" [formControl]="stockLotForm.controls.price" min="1" class="form-input"
          [class.error]="stockLotForm.controls.price.invalid && stockLotForm.controls.price.touched">
        <div class="error-message" *ngIf="stockLotForm.controls.price.invalid && stockLotForm.controls.price.touched">
          {{ 'pages.stock.lots.validation.price' | translate }}
        </div>
      </div>

    </div>

    <div class="form-row">


      <div class="form-group">
        <label for="dot">{{ 'addStock.dotDate' | translate }} <span class="required-mark">*</span></label>
        <input type="text" id="dot" [formControl]="stockLotForm.controls.dot" class="form-input"
          [class.error]="stockLotForm.controls.dot.invalid && stockLotForm.controls.dot.touched" maxlength=" 4"
          placeholder="2324">
        <div class="error-message" *ngIf="stockLotForm.controls.dot.invalid && stockLotForm.controls.dot.touched">
          {{ 'pages.stock.lots.validation.expirationDate' | translate }}
        </div>
      </div>

      <div class="form-group">
        <label for="reason" class="form-label required">
          {{ 'pages.stock.edit.reason' | translate }}*
        </label>
        <select id="reason" [formControl]="stockLotForm.controls.reason" class="form-input">
          <option value="" disabled>{{ 'pages.stock.edit.select_reason' | translate }}</option>
          <option *ngFor="let option of reasonOptions" [value]="option.value">
            {{ option.label | translate }}
          </option>
        </select>
        <div *ngIf="stockLotForm.controls.reason.invalid && stockLotForm.controls.reason.touched" class="error-message">
          {{ 'pages.stock.edit.reason_required' | translate }}
        </div>
      </div>

    </div>

    <div class="form-group">
      <label for="locations">{{'pages.stock.add_stock.locations' | translate}}<span
          class="required-mark"></span></label>
      <app-location-stock-input id="locations" [tagsArray]="locations"
        [placeholder]="('pages.stock.add_stock.locations' | translate) + '...'" [error]="locations.invalid"
        [errorMessage]="'pages.stock.lots.validation.locations' | translate"></app-location-stock-input>
    </div>

    <div class="form-group">
      <label for="notes" class="form-label">
        {{ 'pages.stock.edit.notes' | translate }}
      </label>
      <textarea id="notes" [formControl]="stockLotForm.controls.newNote" class="form-control textarea" rows="3"
        placeholder="{{ 'pages.stock.edit.notes_placeholder' | translate }}">
          </textarea>
    </div>

  </form>

  <div class="modal-actions">
    <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isLoading">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="submit" form="stock-lot-form" class="btn btn-primary" (click)="onSubmit()" [disabled]="isLoading">
      <span *ngIf="isLoading" class="loading-spinner"></span>
      {{ 'common.edit' | translate }}
    </button>
  </div>
</div>